/**
 * Resolves the success button text key for the payment processing screen.
 * Matches legacy renderButtonTitle({ isContinue, type }) from purchases_utils.js.
 *
 * Wrappers (PurchaseFlowWrapper, MobilePurchaseFlow) call this and pass the
 * result as successButtonTextKey so PurchaseFlow stays agnostic of continue vs before-chat.
 */

import type { FlowMode, ConversationType } from '../types';
import { PURCHASE_FLOW_TEXT_KEYS } from './constants';

export interface SuccessButtonKeyParams {
  mode?: FlowMode;
  isContinue?: boolean;
  conversationType?: ConversationType;
}

/**
 * Returns the PURCHASE_FLOW_TEXT_KEYS.* key for the success button.
 * - additionalFunds + isContinue → "Continue"
 * - additionalFunds + !isContinue + conversationType → "Start chat" / "Start video call" / "Start voice call"
 * - else → "OK"
 */
export function getSuccessButtonTextKey(params: SuccessButtonKeyParams): string {
  const { mode, isContinue, conversationType } = params;
  if (mode !== 'additionalFunds') return PURCHASE_FLOW_TEXT_KEYS.BUTTON_OK;
  if (isContinue) return PURCHASE_FLOW_TEXT_KEYS.BUTTON_CONTINUE;
  switch (conversationType) {
    case 'chat': return PURCHASE_FLOW_TEXT_KEYS.BUTTON_START_CHAT;
    case 'video': return PURCHASE_FLOW_TEXT_KEYS.BUTTON_START_VIDEO_CALL;
    case 'voice': return PURCHASE_FLOW_TEXT_KEYS.BUTTON_START_VOICE_CALL;
    default: return PURCHASE_FLOW_TEXT_KEYS.BUTTON_OK;
  }
}
